"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditableHub = exports.editableFields = exports.TYPE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var TYPE = 'Hub';
exports.TYPE = TYPE;
var editableFields = (0, _defineProperty2.default)({}, _constants.ACCOUNT_NAME, '');
exports.editableFields = editableFields;
var EditableHub = (0, _immutable.Record)(editableFields, "Editable" + TYPE);
exports.EditableHub = EditableHub;

var _default = (0, _immutable.Record)(Object.assign({}, {
  id: null,
  createdAt: null,
  familyId: null,
  productId: null,
  domain: null,
  active: null,
  cmsDomain: null,
  appDomain: null,
  trialLength: null,
  trialExpiredAt: null,
  overrides: {},
  salesforce: {},
  productConfig: {},
  scopeLimitInfo: {},
  suspended: null
}, editableFields), TYPE);

exports.default = _default;